module.exports = __webpack_public_path__ + "image/pro_banner_datadome.jpg";